import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
}, options = { showError: true }) => {
    const [ res, error, status ] = await POST(URLS.kpi.kpiStorage.getTableData, {
        id,
    }, options);
    if (error) return { error, status };
    return res || { };
};
